import { Avatar, makeStyles, Theme, Tooltip } from '@material-ui/core';
import React from 'react';
import UserAvatar, { UserDetails } from '../UserAvatar';

export type ActiveUsersProps = {
  maxDisplay?: number;
  users: UserDetails[];
};

const useStyles = makeStyles((theme: Theme) => ({
  activeUsers: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  avatar: {
    border: `1px solid ${theme.palette.background.paper}`,
  },
}));

export const ActiveUsers = ({ users, maxDisplay = 4 }: ActiveUsersProps): JSX.Element => {
  const classes = useStyles();

  const sortedUsers = [...users].sort((user1, user2) => {
    let string1 = user1.displayName ? user1.displayName : `${user1.firstName} ${user1.lastName}`;
    let string2 = user2.displayName ? user2.displayName : `${user2.firstName} ${user2.lastName}`;
    string1 = string1.toLowerCase();
    string2 = string2.toLowerCase();
    return string1 < string2 ? -1 : string1 > string2 ? 1 : 0;
  });

  const extraAvatars = sortedUsers.length > maxDisplay ? sortedUsers.slice(maxDisplay - 1, sortedUsers.length) : [];
  const visibleAvatars = sortedUsers.slice(0, extraAvatars.length ? maxDisplay - 1 : maxDisplay);

  const renderTooltip = (): JSX.Element[] => {
    const tooltipNames = [];

    extraAvatars.slice(0, 34).forEach((avatar, index) => {
      tooltipNames.push(<div key={index}>{avatar.displayName || `${avatar.firstName} ${avatar.lastName}`}</div>);
    });

    // show ellipsis after 34 names to fit tooltip in smaller screens
    if (extraAvatars.length > 34) {
      tooltipNames.push(<div key="extra-avatar">{'...'}</div>);
    }

    return tooltipNames;
  };

  return (
    <div className={classes.activeUsers} data-testid="active-users">
      {visibleAvatars.length > 1
        ? visibleAvatars.map((user, index) => {
            return (
              <UserAvatar
                key={index}
                user={user}
                className={classes.avatar}
                style={{
                  zIndex: visibleAvatars.length - index,
                  marginLeft: index > 0 ? '-7px' : 0,
                }}
              />
            );
          })
        : null}
      {extraAvatars.length ? (
        <Tooltip arrow title={renderTooltip()} placement="top">
          <Avatar className={classes.avatar} style={{ zIndex: 0 }}>{`+${
            extraAvatars.length < 99 ? `${extraAvatars.length}` : '99'
          }`}</Avatar>
        </Tooltip>
      ) : null}
    </div>
  );
};

export default ActiveUsers;
